<template>
  <BaseGridView
    endpoint="v1/Currency/GetData"
    :pageTitle="$t('Currency')"
    :columnDef="(columnDef as Array<ColumnModel>)"
    :searchOptions="_searchOptions"
    :templateDef="templateDef"
  >
    <template #currency_isActive="{ rowData }">
      <span
        :class="rowData.value ? 'badge badge-success' : 'badge badge-danger'"
      >
        {{ rowData.value ? "Active" : "Inactive" }}
      </span>
    </template>
  </BaseGridView>
</template>

<script lang="ts" setup>
import { ColumnModel, CommandModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";

let columnDef = ref([] as ColumnModel[]);

const _searchOptions = {
  fields: ["company.Name", "code", "notation"],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();
const templateDef: TemplateDef = {
  prefix: "currency",
  columnNames: ["isActive"],
};
const commands: Array<CommandModel> = [
  {
    title: "View",
    buttonOption: { cssClass: "e-flat", iconCss: "e-eye e-icons" },
  },
];

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;

  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",
    },
    { field: "code", headerText: instance?.$t("code") },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "currency_isActive",
    },
    { field: "notation", headerText: instance?.$t("notation") },
  ];
};

const onCommandsClick = (commandTitle: string, rowData: any) => {
  alert(commandTitle);
  console.log(rowData);
};
</script>
